import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { TextLocalizer, StringId } from '../localizer/localizer'
import { getStringIdSuffix, PluralizerSuffix } from '../../utils/pluralizer'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as badgeSt from './badge.module.scss'

export interface ISeasonsBadgeProps extends AtfTreatmentProps {
  numOfSeasons?: number
  locale: string
}

interface StringIdsMap {
  [suffix: number]: StringId
}

const stringIds: StringIdsMap = {
  [PluralizerSuffix.one]: 'DV_DP_title_num_of_seasons_one',
  [PluralizerSuffix.few]: 'DV_DP_title_num_of_seasons_few',
  [PluralizerSuffix.many]: 'DV_DP_title_num_of_seasons_many',
  [PluralizerSuffix.other]: 'DV_DP_title_num_of_seasons_other',
}


export const Seasons = ({ numOfSeasons, locale, atfTreatment }: ISeasonsBadgeProps) => {
  if (!numOfSeasons) {
    return null
  }

  const stringIdSuffix = getStringIdSuffix(numOfSeasons, locale)

  if (!stringIdSuffix) {


    return null
  }

  const string = stringIds[stringIdSuffix]

  return (
    <Badge use={badges.TEXT} {...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { className: badgeSt.lightBadge})} >
      <TextLocalizer stringID={string} replace={{numOfSeasons: numOfSeasons.toString()}}/>
    </Badge>
  )
}
